export class WorkflowSearchCriteria{
    isActive: boolean;
    searchText: string;
    statusId: Nullable<number>;
    workflowTypeId: Nullable<number>;
    skip: number;
    take: number;

    constructor(){
        this.isActive = true; // true pour voir tous les workflows, false pour filtrer les terminés
        this.searchText = "";
        this.statusId = null;
        this.workflowTypeId = null;
        this.skip = 0;
        this.take = 20;
    }
}